module.exports = __webpack_public_path__ + "img/lu.8a3f8c98.svg";